import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setDocumentDirection } from '../i18n';
import { detectUserLanguage } from '@/shared/lib';

interface LanguageProviderProps {
  children: React.ReactNode;
  initialLanguage?: string;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children, initialLanguage }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Apply the profile's language on login; otherwise (guest / after logout) keep the
    // currently active language instead of forcing the default.
    const detectedLanguage = initialLanguage ? detectUserLanguage(initialLanguage) : i18n.language;

    i18n.changeLanguage(detectedLanguage);
    setDocumentDirection(detectedLanguage);
  }, [initialLanguage, i18n]);

  return <>{children}</>;
};
